module.exports = __webpack_public_path__ + "static/media/mainlogo.61129060.png";